'use client';

import dynamic from 'next/dynamic';
import React from 'react';

// Dynamically import non-critical components
const CookieConsent = dynamic(
  () => import("@/components/ui/cookie-consent").then((mod) => mod.CookieConsent),
  { ssr: false }
);

// Dynamically import theme provider
const ThemeProvider = dynamic(
  () => import("@/components/theme-provider").then((mod) => mod.ThemeProvider)
);

export function ClientProviders({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="light"
      enableSystem
      disableTransitionOnChange
    >
      {children}
      <CookieConsent />
    </ThemeProvider>
  );
}
